export default "__VITE_ASSET__h$Q9TRko__"